import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/tasks' },
  { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue'), meta: { public: true } },
  { path: '/lock', name: 'lock', component: () => import('@/views/LockView.vue'), meta: { requiresAuth: true } },
  { path: '/tasks', name: 'tasks', component: () => import('@/views/TasksView.vue'), meta: { requiresAuth: true, tab: 'tasks' } },
  {
    path: '/tasks/:listId',
    name: 'list',
    component: () => import('@/views/ListDetailView.vue'),
    meta: { requiresAuth: true, tab: 'tasks' },
    props: true,
  },
  {
    path: '/tasks/:listId/item/:itemId',
    name: 'item',
    component: () => import('@/views/ItemDetailView.vue'),
    meta: { requiresAuth: true, tab: 'tasks' },
    props: true,
  },
  // вкладки-заглушки (P3/P4/P6) — нужны для tab-bar
  { path: '/calendar', name: 'calendar', component: () => import('@/views/PlaceholderView.vue'), meta: { requiresAuth: true, tab: 'calendar' } },
  { path: '/chat', name: 'chat', component: () => import('@/views/PlaceholderView.vue'), meta: { requiresAuth: true, tab: 'chat' } },
  { path: '/me', name: 'me', component: () => import('@/views/PlaceholderView.vue'), meta: { requiresAuth: true, tab: 'me' } },
  { path: '/:pathMatch(.*)*', redirect: '/tasks' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  if (to.meta.public) {
    return auth.isAuthenticated ? { name: 'tasks' } : true;
  }
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login' };
  }
  if (auth.isAuthenticated && auth.locked && to.name !== 'lock') {
    return { name: 'lock' };
  }
  if (to.name === 'lock' && !auth.locked) {
    return { name: 'tasks' };
  }
  return true;
});
